// Startup / publish (shared with x20-creative pattern)
export const INITIATE_STARTUP_CREATION = "INITIATE_STARTUP_CREATION";
export const STARTUP_CREATION_SUCCESS = "STARTUP_CREATION_SUCCESS";
export const STARTUP_CREATION_FAILURE = "STARTUP_CREATION_FAILURE";

export const INITIATE_PUBLISH_NOW = "INITIATE_PUBLISH_NOW";
export const PUBLISH_NOW_SUCCESS = "PUBLISH_NOW_SUCCESS";
export const PUBLISH_NOW_FAILURE = "PUBLISH_NOW_FAILURE";

export const INITIATE_PUBLISH_PAGE_LAYOUT = "INITIATE_PUBLISH_PAGE_LAYOUT";
export const PUBLISH_PAGE_LAYOUT_SUCCESS = "PUBLISH_PAGE_LAYOUT_SUCCESS";
export const PUBLISH_PAGE_LAYOUT_FAILURE = "PUBLISH_PAGE_LAYOUT_FAILURE";

export const INITIATE_PUBLISH_MENU_LAYOUT = "INITIATE_PUBLISH_MENU_LAYOUT";
export const INITIATE_PUBLISH_LANDING_PAGE_LAYOUT =
  "INITIATE_PUBLISH_LANDING_PAGE_LAYOUT";
export const PUBLISH_MENU_LAYOUT_SUCCESS = "PUBLISH_MENU_LAYOUT_SUCCESS";
export const PUBLISH_MENU_LAYOUT_FAILURE = "PUBLISH_MENU_LAYOUT_FAILURE";

// Docs — fetch a single markdown document
export const FETCH_DOC_REQUEST = "FETCH_DOC_REQUEST";
export const FETCH_DOC_SUCCESS = "FETCH_DOC_SUCCESS";
export const FETCH_DOC_FAILURE = "FETCH_DOC_FAILURE";

// Docs — client-side search
export const SEARCH_DOCS = "SEARCH_DOCS";
export const SEARCH_DOCS_RESULTS = "SEARCH_DOCS_RESULTS";
export const SEARCH_DOCS_CLEAR = "SEARCH_DOCS_CLEAR";
